import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import id from "@irati/utils/id"
import {H3} from "@irati/ui/src/Typography"
import {onePxThick} from "@irati/ui/src/global/elevation"

const FlexContainer = styled.div`
  display: flex;
  align-items: center;

  ${(props) =>
    props.withLogo &&
    `
    margin-top: 5px;
    margin-bottom: 5px;
  `}
`

export const Logo = styled.img`
  margin-right: 15px;
  background-color: white;
  border-radius: 3px;
  width: 60px;
  height: 60px;
  ${onePxThick};
`

const Header = ({children, logo, ...props}) => {
  const idNamespace = id("header", props)
  return (
    <FlexContainer id={id("container", idNamespace)} withLogo={logo}>
      {logo && <Logo id={id("logo", idNamespace)} src={logo} />}
      <H3 id={id("title", idNamespace)}>{children}</H3>
    </FlexContainer>
  )
}
Header.propTypes = {
  children: PropTypes.node,
  logo: PropTypes.string
}
Header.defaultProps = {
  logo: null
}

export default Header
